module.exports = __webpack_public_path__ + "media/newstyle/images/img2-footer-es-01f2534393514e0617a41b7a7e3a7528.svg";